<template>
  <div class="rejection-actions-section">
    <div class="rejection-actions-card">
      <h3 class="rejection-actions-title">Rejected Application Review</h3>
      <div class="rejection-actions-buttons">
        <button class="btn btn-success rejection-btn" @click="closeApplication">Approve</button>
        <button class="btn btn-warning rejection-btn" @click="reopenApplication">Disapprove</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RejectionActionButtons',

  methods: {
    closeApplication() {
      this.$prompt('Please input remark (Mandatory)\r\n', 'Approve Rejection', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      })
        .then(({ value }) => {
          if (!value || value.trim() === '') {
            this.$notify.error({
              title: 'Mandatory Field',
              message: 'Please input remark',
              type: 'error',
            })
          } else {
            this.$emit('approve-rejection', value)
          }
        })
        .catch(() => {
          this.$message({ type: 'info', message: 'Canceled' })
        })
    },

    reopenApplication() {
      this.$prompt('Please input remark (Mandatory)\r\n', 'Disapprove Rejection', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      })
        .then(({ value }) => {
          if (!value || value.trim() === '') {
            this.$notify.error({
              title: 'Mandatory Field',
              message: 'Please input remark',
              type: 'error',
            })
          } else {
            this.$emit('decline-rejection', value)
          }
        })
        .catch(() => {
          this.$message({ type: 'info', message: 'Canceled' })
        })
    },
  },
}
</script>

<style scoped>
.rejection-actions-section {
  margin-top: 30px;
}

.rejection-actions-card {
  background: #fff;
  border: 1px solid #e3e6ef;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.rejection-actions-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 10px;
}

.rejection-actions-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.rejection-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}

.rejection-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-success.rejection-btn {
  background-color: #28a745;
  color: white;
}

.btn-success.rejection-btn:hover {
  background-color: #218838;
}

.btn-warning.rejection-btn {
  background-color: #ffc107;
  color: #212529;
}

.btn-warning.rejection-btn:hover {
  background-color: #e0a800;
}
</style>
